import React from 'react';
import PropTypes from 'prop-types';

import { StyledTextField, StyledTextFieldContainer } from '../../../../../../components/Inputs';
import InputLabel from '../../../../../../components/v2/InputLabel';

import texts from './texts.json';

const NUMBER_OF_ROWS = 12;

const TemplateSection = ({
  showSubject,
  setEmailSubject,
  emailSubject,
  msgBody,
  setMsgBody,
}) => (
  <>
    {showSubject && (
      <StyledTextFieldContainer $withMargin>
        <InputLabel>{texts.emailSubject}</InputLabel>
        <StyledTextField value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} />
      </StyledTextFieldContainer>
    )}
    <StyledTextFieldContainer $withMargin>
      <InputLabel>{texts.messageBody}</InputLabel>
      <StyledTextField
        value={msgBody}
        onChange={(e) => setMsgBody(e.target.value)}
        multiline
        rows={NUMBER_OF_ROWS}
      />
    </StyledTextFieldContainer>
  </>
);

TemplateSection.propTypes = {
  showSubject: PropTypes.bool.isRequired,
  emailSubject: PropTypes.string.isRequired,
  msgBody: PropTypes.string.isRequired,
  setEmailSubject: PropTypes.func.isRequired,
  setMsgBody: PropTypes.func.isRequired,
};

export default TemplateSection;
